import { v4 as uuidv4 } from 'uuid';
import { RichText } from '../../../../vtex-apps/rich-text/RichText/default';
import { Image } from '../../../../vtex-apps/store-components/Image/default';
import { FlexLayoutRow, FlexLayoutCol } from '../../../../vtex-apps/flex-layout/FlexLayout/default';
import { SliderLayout } from '../../../../vtex-apps/slider-layout/SliderLayout/default';
import { VisibilityLayout } from '../../../../vtex-apps/VisibilityLayout/default';
export default function TipbarGroup() {
	return {
		componentName: 'VisibilityLayout',
		componentId: uuidv4(),
		componentGroup: 'TipbarGroup',
		props: VisibilityLayout({ mzTitle: 'MZ | Informações de destaque (On/Off)' }).props,
		variables,
		childrenComponents: [
			FlexLayoutRow(
				{
					blockClass: 'flex-row__tipbar-group-2',
					preserveLayoutOnMobile: true,
					mzTitle: 'MZ | Informações de destaque',
				},
				[
					SliderLayout(
						{
							showNavigationArrows: 'mobileOnly',
							mzTitle: 'MZ | Conteúdo',
							showPaginationDots: 'mobileOnly',
							blockClass: 'slider-layout__tipbar-group-2',
							itemsPerPage: {
								desktop: 4,
								tablet: 2,
								phone: 1,
							},
						},
						[
							VisibilityLayout({ mzTitle: 'MZ | Coluna 1 (On/Off)' }, [
								FlexLayoutCol(
									{
										preventVerticalStretch: true,
										mzTitle: 'MZ | Destaque - Coluna 1',
										blockClass: 'flex-col__tipbar-group-2',
									},
									[
										Image({
											src: 'https://hefesto-upload-images.s3.amazonaws.com/1683060470432-truck-tipbar-icon.png',
											maxHeight: '48px',
										}),
										RichText({
											text: 'Frete grátis para todo o Brasil em produtos selecionados',
											blockClass: 'rich-text__tipbar-group-2',
										}),
									],
								),
							]),
							VisibilityLayout({ mzTitle: 'MZ | Coluna 2 (On/Off)' }, [
								FlexLayoutCol(
									{
										preventVerticalStretch: true,
										mzTitle: 'MZ | Destaque - Coluna 2',
										blockClass: 'flex-col__tipbar-group-2',
									},
									[
										Image({
											src: 'https://hefesto-upload-images.s3.amazonaws.com/1683060441889-cartao-tipbar-icon.png',
											maxHeight: '48px',
										}),
										RichText({
											text: 'Parcele sua compra em até 6x sem juros no cartão \n <br> [Consulte Condições](/)',
											blockClass: 'rich-text__tipbar-group-2',
										}),
									],
								),
							]),
							VisibilityLayout({ mzTitle: 'MZ | Coluna 3 (On/Off)' }, [
								FlexLayoutCol(
									{
										preventVerticalStretch: true,
										mzTitle: 'MZ | Destaque - Coluna 3',
										blockClass: 'flex-col__tipbar-group-2',
									},
									[
										Image({
											src: 'https://hefesto-upload-images.s3.amazonaws.com/1683060441889-cartao-tipbar-icon.png',
											maxHeight: '48px',
										}),
										RichText({
											text: 'Ganhe até 5% de desconto no boleto ou depósito bancário',
											blockClass: 'rich-text__tipbar-group-2',
										}),
									],
								),
							]),
							VisibilityLayout({ mzTitle: 'MZ | Coluna 4 (On/Off)' }, [
								FlexLayoutCol(
									{
										preventVerticalStretch: true,
										mzTitle: 'MZ | Destaque - Coluna 4',
										blockClass: 'flex-col__tipbar-group-2',
									},
									[
										Image({
											src: 'https://hefesto-upload-images.s3.amazonaws.com/1683060470432-truck-tipbar-icon.png',
											maxHeight: '48px',
										}),
										RichText({
											text: 'Mais de 1200 itens a pronta-entrega te esperando',
											blockClass: 'rich-text__tipbar-group-2',
										}),
									],
								),
							]),
							VisibilityLayout({ mzTitle: 'MZ | Coluna 5 (On/Off)' }, [
								FlexLayoutCol(
									{
										preventVerticalStretch: true,
										mzTitle: 'MZ | Destaque - Coluna 5',
										blockClass: 'flex-col__tipbar-group-2',
									},
									[
										Image({
											src: 'https://hefesto-upload-images.s3.amazonaws.com/1683060470432-truck-tipbar-icon.png',
											maxHeight: '48px',
										}),
										RichText({
											text: 'Mais de 1200 itens a pronta-entrega te esperando',
											blockClass: 'rich-text__tipbar-group-2',
										}),
									],
								),
							]),
							VisibilityLayout({ mzTitle: 'MZ | Coluna 6 (On/Off)' }, [
								FlexLayoutCol(
									{
										preventVerticalStretch: true,
										mzTitle: 'MZ | Destaque - Coluna 6',
										blockClass: 'flex-col__tipbar-group-2',
									},
									[
										Image({
											src: 'https://hefesto-upload-images.s3.amazonaws.com/1683060470432-truck-tipbar-icon.png',
											maxHeight: '48px',
										}),
										RichText({
											text: 'Mais de 1200 itens a pronta-entrega te esperando',
											blockClass: 'rich-text__tipbar-group-2',
										}),
									],
								),
							]),
						],
					),
				],
			),
		],
	};
}

const variables = [
	{
		type: 'color',
		list: [
			{ from: '--white', to: '--tg-2-background', name: 'Background' },
			{ from: '--text-color-1', to: '--tg-2-text-color', name: 'Text' },
			{ from: '--brand-color-primary-pure', to: '--tg-2-slider-color', name: 'Slider' },
			{ from: '--white', to: '--tg-2-slider-arrow-color', name: 'Arrow' },
			{ from: '--brand-color-primary-pure', to: '--tg-2-dots-color', name: 'Dots' },
		],
	},
	{
		type: 'borderRadius',
		list: [{ from: '--border-radius-sm', to: '--tg-2-slider-radius', name: 'Slider Border Radius' }],
	},
	{
		type: 'fontSize',
		list: [{ from: '--font-size-sm', to: '--tg-2-text-fs', name: 'Text' }],
	},
	{
		type: 'typography',
		list: [{ from: '--main-font', to: '--tg-2-ff', name: 'Font Family' }],
	},
	{
		type: 'spacing',
		list: [
			{ from: '--spacing-xxs', to: '--tg-2-dot-width', name: 'Dot Width' },
			{ from: '--spacing-xxs', to: '--tg-2-dot-width-active', name: 'Dot Width Active' },
			{ from: '--spacing-nano', to: '--tg-2-dot-height', name: 'Dot Height' },
			{ from: '--spacing-nano', to: '--tg-2-dot-height-active', name: 'Dot Height Active' },
		],
	},
];
